module.exports = {
      id: "whatsapp-icon-usage",
      viewBox: "0 0 24.99 25.091",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#whatsapp-icon",
      toString: function () {
        return this.url;
      }
    }